import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const sampleCheckDiagram = svgToTinyDataUri(
  `<svg width="220" height="110" viewBox="0 0 220 110" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!-- Check background -->
  <rect x="1" y="1" width="218" height="108" rx="4" fill="white" stroke="#E6E5EA" stroke-width="1"/>

  <!-- Top line placeholders -->
  <rect x="12" y="12" width="60" height="6" rx="1" fill="#C4C4C4"/>
  <rect x="148" y="12" width="60" height="6" rx="1" fill="#C4C4C4"/>

  <!-- Middle lines -->
  <rect x="12" y="28" width="196" height="4" rx="1" fill="#E6E5EA"/>
  <rect x="12" y="40" width="140" height="4" rx="1" fill="#E6E5EA"/>

  <!-- Signature line -->
  <line x1="120" y1="60" x2="208" y2="60" stroke="#9391A0" stroke-width="1"/>

  <!-- Signature scribble -->
  <path d="M130 58 Q140 50 150 58 Q160 66 170 55 Q180 44 190 58 Q195 62 200 56" stroke="#575560" stroke-width="1.5" fill="none" stroke-linecap="round"/>

  <!-- Bottom section - MICR line area -->
  <rect x="12" y="75" width="196" height="24" rx="2" fill="#F5F5F7"/>

  <!-- Routing number block -->
  <rect x="20" y="80" width="55" height="8" rx="1" fill="#9391A0"/>

  <!-- Account number block -->
  <rect x="90" y="80" width="65" height="8" rx="1" fill="#9391A0"/>

  <!-- Check number block -->
  <rect x="170" y="80" width="30" height="8" rx="1" fill="#C4C4C4"/>

  <!-- Labels -->
  <text x="47" y="98" font-family="system-ui, sans-serif" font-size="8" font-weight="600" fill="#575560" text-anchor="middle">ROUTING #</text>
  <text x="122" y="98" font-family="system-ui, sans-serif" font-size="8" font-weight="600" fill="#575560" text-anchor="middle">ACCOUNT #</text>
</svg>`
);
